import { IHeader } from "../components/AgGrid/index";
import { SCKpis } from "../generic/generic-sc-domain";
import { AgFormat } from "../utils/agGridFormat";
import { ProfileEnum } from "./salescredit-role-types";
export interface ISCProfileDictionary {
  GetKpi(profile: string, kpi: string): string;
  GetGridFields(profile: string): Array<{ Kpi: string; HeaderFormat: IHeader }>;
}
const textRight = "text-right";
const SC_YTD_KEURO = "SC YTD (K€)";
const SC_YTD_1_KEURO = "SC YTD-1 (K€)";
const SC_FY_1_KEURO = "SC FY-1 (K€)";
const SC_YTD_2_KEURO = "SC YTD-2 (K€)";
const SC_YTD_3_KEURO = "SC YTD-3 (K€)";

export class SCProfileDictionary implements ISCProfileDictionary {
  private readonly kpis: {
    [profile: string]: { kpis: { [kpi: string]: string } };
  };

  private gridFields!: {
    [profile: string]: Array<{
      Kpi: string;
      HeaderFormat: IHeader;
    }>;
  };
  public constructor() {
    this.kpis = {};
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER] = { kpis: {} };
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_YTD] =
      SCKpis.SC_YTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_YTD_1] =
      SCKpis.SC_YTD_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_YTD_2] =
      SCKpis.SC_YTD_EX_2;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_YTD_3] =
      SCKpis.SC_YTD_EX_3;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_COM_YTD] =
      SCKpis.SC_COM_YTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_COM_YTD_1] =
      SCKpis.SC_COM_YTD_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_CSA_YTD] =
      SCKpis.SC_CSA_YTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_CSA_YTD_1] =
      SCKpis.SC_CSA_YTD_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_D_1] =
      SCKpis.SC_D_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_D_2] =
      SCKpis.SC_D_EX_2;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_MTD] =
      SCKpis.SC_MTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_SC] =
      SCKpis.SC_SC_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_SC_1] =
      SCKpis.SC_SC_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_SC_2] =
      SCKpis.SC_SC_EX_2;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_WTD] =
      SCKpis.SC_WTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_WTD_1] =
      SCKpis.SC_WTD_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_WTD_2] =
      SCKpis.SC_WTD_EX_2;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_WTD_3] =
      SCKpis.SC_WTD_EX_3;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_FEES_YTD] =
      SCKpis.SC_FEES_YTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_FEES_YTD_1] =
      SCKpis.SC_FEES_YTD_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_TRADPL_YTD] =
      SCKpis.SC_TRADPL_YTD_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_TRADPL_YTD_1] =
      SCKpis.SC_TRADPL_YTD_EX_1;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_YOY_PER] =
      SCKpis.SC_YOY_PER_EX;
    this.kpis[ProfileEnum.CASH_EQUITY_TRADER].kpis[SCKpis.SC_Y_VS_Y1] =
      SCKpis.SC_Y_VS_Y1_EX;
    this.BuildGridFields();
  }

  public GetKpi(profile: string, kpi: string): string {
    if (
      this.kpis[profile] === undefined ||
      this.kpis[profile].kpis === undefined
    ) {
      return kpi;
    }
    if (this.kpis[profile].kpis[kpi] === undefined) {
      return kpi;
    }
    return this.kpis[profile].kpis[kpi];
  }

  public GetGridFields(
    profile: string
  ): Array<{ Kpi: string; HeaderFormat: any }> {
    if (this.gridFields[profile] === undefined) {
      return this.gridFields[ProfileEnum.EMPTY];
    }
    return this.gridFields[profile];
  }

  // tslint:disable-next-line: no-big-function
  private BuildGridFields() {
    this.gridFields = {};

    this.gridFields[ProfileEnum.EMPTY] = [
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD,
          filter: "number",
          headerName: SC_YTD_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_1,
          filter: "number",
          headerName: SC_YTD_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_1,
      },
      {
        HeaderFormat: {
          cellClass: textRight,
          cellStyle: AgFormat.AgVarianceStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YOY_PER,
          filter: "number",
          headerName: "Var (%)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgVariancePercentageGroupCell,
          width: 100,
        },
        Kpi: SCKpis.SC_YOY_PER,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_SC_1,
          filter: "number",
          headerName: SC_FY_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_SC_1,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_MARKUP_YTD,
          filter: "number",
          headerName: "o/w MU YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_MARKUP_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_F2Y_YTD,
          filter: "number",
          headerName: "o/w F(Y) YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_F2Y_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_CVA_YTD,
          filter: "number",
          headerName: "o/w CVA YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_CVA_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_NOMINAL_YTD,
          filter: "number",
          headerName: "Deal nominal YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_NOMINAL_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_2,
          filter: "number",
          headerName: SC_YTD_2_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_2,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_3,
          filter: "number",
          headerName: SC_YTD_3_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_3,
      },
    ];

    this.gridFields[ProfileEnum.TICKERS] = [
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD,
          filter: "number",
          headerName: SC_YTD_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_1,
          filter: "number",
          headerName: SC_YTD_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_1,
      },
      {
        HeaderFormat: {
          cellClass: textRight,
          cellStyle: AgFormat.AgVarianceStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YOY_PER,
          filter: "number",
          headerName: "Var (%)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgVariancePercentageGroupCell,
          width: 100,
        },
        Kpi: SCKpis.SC_YOY_PER,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_SC_1,
          filter: "number",
          headerName: SC_FY_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_SC_1,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_MARKUP_YTD,
          filter: "number",
          headerName: "o/w MU YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_MARKUP_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_F2Y_YTD,
          filter: "number",
          headerName: "o/w F(Y) YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_F2Y_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_CVA_YTD,
          filter: "number",
          headerName: "o/w CVA YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_CVA_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YOICE_YTD,
          filter: "number",
          headerName: "Voice YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YOICE_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_ELEC_YTD,
          filter: "number",
          headerName: "Elec YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_ELEC_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_LOW_NO_RISK,
          filter: "number",
          headerName: "Low To No Risk (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 170,
        },
        Kpi: SCKpis.SC_LOW_NO_RISK,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_ONE_WAY_YTD,
          filter: "number",
          headerName: "One Way YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 160,
        },
        Kpi: SCKpis.SC_ONE_WAY_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_AXE_YTD,
          filter: "number",
          headerName: "AXE YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_AXE_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_PURE_MU_YTD,
          filter: "number",
          headerName: "PURE MU YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 160,
        },
        Kpi: SCKpis.SC_PURE_MU_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_PRIMARY_YTD,
          filter: "number",
          headerName: "Primary YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_PRIMARY_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_RISK_FREE_YTD,
          filter: "number",
          headerName: "Risk Free YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 160,
        },
        Kpi: SCKpis.SC_RISK_FREE_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_TWO_WAY_YTD,
          filter: "number",
          headerName: "Two Way YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 160,
        },
        Kpi: SCKpis.SC_TWO_WAY_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_2,
          filter: "number",
          headerName: SC_YTD_2_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_2,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_NOMINAL_YTD,
          filter: "number",
          headerName: "Deal nominal YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_NOMINAL_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_3,
          filter: "number",
          headerName: SC_YTD_3_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_3,
      },
    ];

    this.gridFields[ProfileEnum.CASH_EQUITY_SALES] = [
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD,
          filter: "number",
          headerName: SC_YTD_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_1,
          filter: "number",
          headerName: SC_YTD_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_1,
      },
      {
        HeaderFormat: {
          cellClass: textRight,
          cellStyle: AgFormat.AgVarianceStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YOY_PER,
          filter: "number",
          headerName: "Var (%)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgVariancePercentageGroupCell,
          width: 100,
        },
        Kpi: SCKpis.SC_YOY_PER,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_SC_1,
          filter: "number",
          headerName: SC_FY_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_SC_1,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_COM_YTD,
          filter: "number",
          headerName: "COM YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_COM_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_FEES_YTD,
          filter: "number",
          headerName: "FEES YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_FEES_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_TRADPL_YTD,
          filter: "number",
          headerName: "TRADE P&L (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_TRADPL_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_CSA_YTD,
          filter: "number",
          headerName: "CSA YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_CSA_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_NOMINAL_YTD,
          filter: "number",
          headerName: "Deal nominal YTD(K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_NOMINAL_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_2,
          filter: "number",
          headerName: SC_YTD_2_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_2,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_3,
          filter: "number",
          headerName: SC_YTD_3_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_3,
      },
    ];

    this.gridFields[ProfileEnum.CASH_EQUITY_TRADER] = [
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_EX,
          filter: "number",
          headerName: SC_YTD_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_EX,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_EX_1,
          filter: "number",
          headerName: SC_YTD_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_EX_1,
      },
      {
        HeaderFormat: {
          cellClass: textRight,
          cellStyle: AgFormat.AgVarianceStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YOY_PER,
          filter: "number",
          headerName: "Var (%)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgVariancePercentageGroupCell,
          width: 100,
        },
        Kpi: SCKpis.SC_YOY_PER_EX,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_SC_EX_1,
          filter: "number",
          headerName: SC_FY_1_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_SC_EX_1,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_COM_YTD_EX,
          filter: "number",
          headerName: "COM YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_COM_YTD_EX,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_FEES_YTD_EX,
          filter: "number",
          headerName: "FEES YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_FEES_YTD_EX,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_TRADPL_YTD_EX,
          filter: "number",
          headerName: "TRADE P&L (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_TRADPL_YTD_EX,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_CSA_YTD_EX,
          filter: "number",
          headerName: "CSA YTD (K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_CSA_YTD_EX,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_NOMINAL_YTD,
          filter: "number",
          headerName: "Deal nominal YTD(K€)",
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_NOMINAL_YTD,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_EX_2,
          filter: "number",
          headerName: SC_YTD_2_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_EX_2,
      },
      {
        HeaderFormat: {
          aggFunc: AgFormat.columnTotal,
          cellClass: textRight,
          cellStyle: AgFormat.AgNumaricStyle,
          comparator: AgFormat.AgNumberComparator,
          enableValue: true,
          field: SCKpis.SC_YTD_EX_3,
          filter: "number",
          headerName: SC_YTD_3_KEURO,
          suppressSizeToFit: true,
          valueGetter: AgFormat.AgGridFormatMoney,
          width: 150,
        },
        Kpi: SCKpis.SC_YTD_EX_3,
      },
    ];
  }
}
